import { Dropdown } from 'semantic-ui-react';
import styled from 'styled-components';

export const TooltipWrapper = styled.div`
  margin: 0;
  border: 1px solid #f5f5f5;
  background-color: #f3f4f5;
  border-radius: 5px;
  padding: 5px;
`
export const FilterWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  .ui.selection.dropdown {
    width: 250px !important;
    .divider.text {
      max-width: 180px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .ui.selection.active.dropdown .menu {
    width: 250px !important;
  }
`

export const StyledSkeletonWrapper = styled.div`
padding: 1.25em 2em;
.skeleton-chart {
  display: flex;
  justify-content: space-evenly;
  align-items: flex-end;
  height: 300px; 
  width: 100%;
  padding: 20px;
  background-color: #f5f5f5; 
  position: relative;
  overflow: hidden;
}

.skeleton-bar {
  width: 70px;
  background: linear-gradient(90deg, #e0e0e0 25%, #d6d6d6 50%, #e0e0e0 75%);
  background-size: 400% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
}

.bar1 { height: 40%; }
.bar2 { height: 60%; }
.bar3 { height: 30%; }

@keyframes loading {
  0% { background-position: 100% 0; }
  100% { background-position: -100% 0; }
}
`
export const StyledFiltersOptions = styled(Dropdown)`
font-size: 1.2rem !important;
 .divider.text {
  margin: 0.45238095em 0 0.45238095em -1em !important; 
 }
 .menu.transition {
   margin-left: -6em !important;
    .item {
      padding: 0px !important;
    }
 }

 .ui.checkbox {
   padding : .78571429rem 1.14285714rem !important;
   width: 100%;
 }
`
export const StyledFilterValues = styled.div`
display: flex;
align-items: baseline;
justify-content: end;
flex-wrap: wrap;
gap: 10px;
margin-bottom: 10px;
`